export const options = [
  { value: "software-developer", label: "Software Developer" },
  { value: "full-stack-developer", label: "Full-stack Developer" },
  { value: "front-end-developer", label: "Front-end Developer" },
  { value: "back-end-developer", label: "Back-end Developer" },
  { value: "business-analyst", label: "Business Analyst" },
  { value: "ux-ui-designer", label: "UX / UI Designer" },
  { value: "software-tester", label: "Software Tester / QA Engineer" },
  { value: "qa-lead", label: "QA Lead / Test Manager" },
  { value: "project-manager", label: "Project Manager" },
  { value: "enterprise-architect", label: "Enterprise Architect" },
  { value: "software-architect", label: "Software Architect" },
  { value: "scrum-master", label: "Scrum Master" },
  { value: "team-lead", label: "Team Lead / Tech Lead" },
  { value: "other", label: "Other" },
];

export const languages = [
  {
    value: "python",
    name: "Python",
  },
  {
    value: "javascript",
    name: "JavaScript",
  },
  {
    value: "html",
    name: "HTML",
  },
  {
    value: "css",
    name: "CSS",
  },
  {
    value: "java",
    name: "Java",
  },
  {
    value: "swift",
    name: "Swift",
  },
  {
    value: "c++",
    name: "C++",
  },
  {
    value: "c#",
    name: "C#",
  },
  {
    value: "r",
    name: "R",
  },
  {
    value: "golang",
    name: "Golang (Go)",
  },
  {
    value: "php",
    name: "PHP",
  },
  {
    value: "typeScript",
    name: "TypeScript",
  },

  {
    value: "scala",
    name: "Scala",
  },

  {
    value: "shell",
    name: "Shell",
  },

  {
    value: "powershell",
    name: "PowerShell",
  },
  {
    value: "scala",
    name: "Scala",
  },

  {
    value: "perl",
    name: "Perl",
  },

  {
    value: "haskell",
    name: "Haskell",
  },
  {
    value: "kotlin",
    name: "Kotlin",
  },
  {
    value: "visualbasic",
    name: "Visual Basic .NET",
  },
  {
    value: "sql",
    name: "SQL",
  },
  {
    value: "delphi",
    name: "Delphi",
  },
  {
    value: "groovy",
    name: "Groovy",
  },
  {
    value: "lua",
    name: "Lua",
  },
  {
    value: "rust",
    name: "Rust",
  },
  {
    value: "ruby",
    name: "Ruby",
  },
  {
    value: "c",
    name: "C",
  },
  {
    value: "dart",
    name: "Dart",
  },
  {
    value: "matlab",
    name: "Matlab",
  },
  {
    value: "nosql",
    name: "NoSQL",
  },
  {
    value: "julia",
    name: "Julia",
  },
  {
    value: "fortran",
    name: "Fortran",
  },
  {
    value: "cobal",
    name: "COBOL",
  },
  {
    value: "lisp",
    name: "Lisp",
  },
  {
    value: "foxpro",
    name: "(Visual) FoxPro",
  },
  {
    value: "ada",
    name: "Ada",
  },
  {
    value: "prolog",
    name: "Prolog",
  },
  {
    value: "plsql",
    name: "PL/SQL",
  },
  {
    value: "bash",
    name: "Bash",
  },
];

export const levels = [
  {
    value: 1,
    name: "Beginner",
  },
  {
    value: 2,
    name: "Advanced Beginner",
  },
  {
    value: 3,
    name: "Intermediate",
  },
  {
    value: 4,
    name: "Advanced",
  },
  {
    value: 5,
    name: "Expert",
  },
];

export const levelValue = [
  {
    value: 1,
    name: "Beginner",
  },
  {
    value: 2,
    name: "Advanced Beginner",
  },
  {
    value: 3,
    name: "Intermediate",
  },
  {
    value: 4,
    name: "Advanced",
  },
  {
    value: 5,
    name: "Expert",
  },
];

//This class contains the array lists

export const languagesNames = [
  { value: "English", label: "English" },
  { value: "French", label: "French" },
  { value: "Spanish", label: "Spanish" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "German", label: "German" },
  { value: "Italian", label: "Italian" },
  { value: "Swahili", label: "Swahili" },
  { value: "Hindi", label: "Hindi" },
  { value: "Swedish", label: "Swedish" },
  // { value: "Other", label: "Other" }
];

export const monthNames = [
  { value: 1, name: "January" },
  { value: 2, name: "February" },
  { value: 3, name: "March" },
  { value: 4, name: "April" },
  { value: 5, name: "May" },
  { value: 6, name: "June" },
  { value: 7, name: "July" },
  { value: 8, name: "August" },
  { value: 9, name: "September" },
  { value: 10, name: "October" },
  { value: 11, name: "November" },
  { value: 12, name: "December" },
];

export const methodologyNames = ["Agile", "Scrum", "Kanban"];

export const primaryRoles = [
  "Software Developer",
  "Full-stack Developer",
  "Front-end Developer",
  "Back-end Developer",
  "Business Analyst",
  "UX / UI Designer",
  "Software Tester / QA Engineer",
  "QA Lead / Test Manager",
  "Project Manager",
  "Enterprise Architect",
  "Software Architect",
  "Scrum Master",
  "Team Lead / Tech Lead",
  "Other",
];

export const operatingSystemNames = [
  "RHEL Linux",
  "Fedora Linux",
  "CentOs Linux",
  "Debian Linux",
  "SLES Linux",
  "SuSe Linux",
  "Ubuntu Linux",
  "MS Windows XP/7/8/10",
  "MS Windows Server 2008/2012/2016/2019",
  "MacOS",
  "IBM",
  "Aix",
  "Unix",
  "HP-UX",
  "Unix OS/2",
];

export const databaseNames = [
  "Oracle RDBMS",
  "Oracle DB BM DB2",
  "Microsoft SQL Server",
  "Sybase",
  "ASE",
  "SAP",
  "HANA",
  "Teradata",
  "ADABAS",
  "MySQL",
  "FileMaker",
  "Informix",
  "SQLite",
  "PostgreSQL",
  "Amazon RDS",
  "MongoDB",
  "Redis",
  "CouchDB",
  "Neo4j",
  "OrientDB",
  "Couchbase",
  "Toad",
  "Hadoop",
  "HDFS",
  "MariaDB",
  "Informix",
  "Dynamic Servers",
  "RDM Server",
];

export const integrationNames = [
  "API",
  "COBRA",
  "Data",
  "Power",
  "DCOM",
  "ESB",
  "EJB",
  "IDL",
  "JMS",
  "MQ",
  "OLE",
  "RestAPI",
  "RMI",
  "SOAP",
  "Web Services",
  "XML",
];

export const frameworkNames = [
  "Alpine.js",
  "Angular",
  "ASP.NET",
  "Backbone.js",
  "Blade",
  "Django",
  "Dropwizard",
  "Eleventy",
  "Elixir",
  "Ember.js",
  "Express",
  "Expo",
  "Fiber",
  "Flask",
  "Flutter",
  "Gatsby",
  "Hugo",
  "Ionic",
  "Jekyll",
  "KeystoneJS",
  "Koa",
  "Laravel",
  "Lit",
  "Meteor",
  "NativeScript",
  "NestJS",
  "Next.js",
  "Node.js",
  "Nuxt.js",
  "Play",
  "Preact",
  "Quasar",
  "Rails",
  "React",
  "React Native",
  "RedwoodJS",
  "Remix",
  "Sails.js",
  "Sanity",
  "SolidJS",
  "Spring",
  "Stimulus",
  "Strapi",
  "Struts",
  "Svelte",
  "Vaadin",
  "VueJS"
];

export const careerBreakType = [
  "Bereavement",
  "Career transition",
  "Caregiving",
  "Fulltime-time parenting",
  "Gap year",
  "Layoff/position eliminated",
  "Health and well-being",
  "Personal goal pursuit",
  "Professional development",
  "Relocation",
  "Travel",
  "Voluntary work",
];
export const skillsUsedInProjects = [
  {
    value: "python",
    label: "Python",
  },
  {
    value: "javascript",
    label: "JavaScript",
  },
  {
    value: "html",
    label: "HTML",
  },
  {
    value: "css",
    label: "CSS",
  },
  {
    value: "java",
    label: "Java",
  },
  {
    value: "swift",
    label: "Swift",
  },
  {
    value: "c++",
    label: "C++",
  },
  {
    value: "c#",
    label: "C#",
  },
  {
    value: "r",
    label: "R",
  },
  {
    value: "golang",
    label: "Golang (Go)",
  },
  {
    value: "php",
    label: "PHP",
  },
  {
    value: "typeScript",
    label: "TypeScript",
  },
  {
    value: "scala",
    label: "Scala",
  },
  {
    value: "shell",
    label: "Shell",
  },
  {
    value: "powershell",
    label: "PowerShell",
  },
  {
    value: "scala",
    label: "Scala",
  },
  {
    value: "perl",
    label: "Perl",
  },
  {
    value: "haskell",
    label: "Haskell",
  },
  {
    value: "kotlin",
    label: "Kotlin",
  },
  {
    value: "visualbasic",
    label: "Visual Basic .NET",
  },
  {
    value: "sql",
    label: "SQL",
  },
  {
    value: "delphi",
    label: "Delphi",
  },
  {
    value: "groovy",
    label: "Groovy",
  },
  {
    value: "lua",
    label: "Lua",
  },
  {
    value: "rust",
    label: "Rust",
  },
  {
    value: "ruby",
    label: "Ruby",
  },
  {
    value: "c",
    label: "C",
  },
  {
    value: "dart",
    label: "Dart",
  },
  {
    value: "matlab",
    label: "Matlab",
  },
  {
    value: "nosql",
    label: "NoSQL",
  },
  {
    value: "julia",
    label: "Julia",
  },
  {
    value: "fortran",
    label: "Fortran",
  },
  {
    value: "cobal",
    label: "COBOL",
  },
  {
    value: "lisp",
    label: "Lisp",
  },
  {
    value: "foxpro",
    label: "(Visual) FoxPro",
  },
  {
    value: "ada",
    label: "Ada",
  },
  {
    value: "prolog",
    label: "Prolog",
  },
  {
    value: "plsql",
    label: "PL/SQL",
  },
  {
    value: "bash",
    label: "Bash",
  },
  {
    value: "wordpress",
    label: "Wordpress",
  },
  {
    value: "optimizely",
    label: "Optimizely",
  },
  {
    value: "hubspot CMS Hub",
    label: "Hubspot CMS Hub",
  },
  {
    value: "joomla",
    label: "Joomla",
  },
  {
    value: "wooCommerce",
    label: "WooCommerce",
  },
  {
    value: "drupal",
    label: "Drupal",
  },
  {
    value: "squarespace",
    label: "Squarespace",
  },
  {
    value: "bigCommerce",
    label: "BigCommerce",
  },
  {
    value: "wix",
    label: "Wix",
  },
  {
    value: "shopify",
    label: "Shopify",
  },
  {
    value: "ghost",
    label: "Ghost",
  },
  {
    value: "umbraco",
    label: "Umbraco",
  },
  {
    value: "magento",
    label: "Magento",
  },
  {
    value: "textpattern",
    label: "Textpattern",
  },
  {
    value: "blogger",
    label: "Blogger",
  },
  {
    value: "oracle netsuite",
    label: "Oracle Netsuite",
  },
  {
    value: "SAP",
    label: "SAP",
  },
  {
    value: "microsoft dynamics 365",
    label: "Microsoft Dynamics 365",
  },
  {
    value: "epicor ERP",
    label: "Epicor ERP",
  },
  {
    value: "sage intacct",
    label: "Sage Intacct",
  },
  {
    value: "salesforce",
    label: "Salesforce",
  },
  {
    value: "hubspot",
    label: "HubSpot",
  },
  {
    value: "pipedrive",
    label: "PipeDrive",
  },
  {
    value: "salesflare",
    label: "Salesflare",
  },
  {
    value: "freshsales",
    label: "Freshsales",
  },
  {
    value: "soho CRM",
    label: "Soho CRM",
  },
  {
    value: "apptivo",
    label: "Apptivo",
  },
  {
    value: "servicenow",
    label: "ServiceNow",
  },
  {
    value: "freshdesk",
    label: "Freshdesk",
  },
  {
    value: "ninjaone",
    label: "NinjaOne",
  },
  {
    value: "superops",
    label: "superops",
  },
  {
    value: "haloITSM",
    label: "HaloITSM",
  },
  {
    value: "BMC Remedy",
    label: "BMC Remedy",
  },
  {
    value: "safe",
    label: "SAFe",
  },
  {
    value: "zendesk",
    label: "Zendesk",
  },
  {
    value: "yaml",
    label: "YAML",
  },
  {
    value: "wan",
    label: "WAN",
  },
  {
    value: "ui test automation",
    label: "UI Test Automation",
  },
  {
    value: "tcp-ip",
    label: "TCP-IP",
  },
  {
    value: "r statistics",
    label: "R Statistics",
  },
  {
    value: "r programming language",
    label: "R programming language",
  },
  {
    value: "rest apis",
    label: "Rest API",
  },
  {
    value: "restful apis",
    label: "RESTful APIS",
  },
  {
    value: "ldap",
    label: "LDAP",
  },
  {
    value: "j2ee",
    label: "J2EE",
  },
  {
    value: "e-commerce",
    label: "E-commerce",
  },
  {
    value: "jira service management",
    label: "Jira Service Management",
  },
  {
    value: "zendesk ITSM",
    label: "Zendesk ITSM",
  },
  {
    value: "itil",
    label: "ITIL",
  },
  {
    value: "prince2",
    label: "PRINCE2",
  },
  {
    value: "material ui",
    label: "Material UI",
  },
  {
    value: "bootstrap",
    label: "Bootstrap",
  },

  {
    value: "fogbugz",
    label: "FogBugz",
  },
  {
    value: "axosoft",
    label: "Axosoft",
  },
  {
    value: "trac",
    label: "Trac",
  },
  {
    value: "redmine",
    label: "RedMine",
  },
  {
    value: "mantis",
    label: "Mantis",
  },
  {
    value: "bugzilla",
    label: "BugZilla",
  },
  {
    value: "userback",
    label: "Userback",
  },
  {
    value: "zoho bug tracker",
    label: "Zoho Bug Tracker",
  },
  {
    value: "clickup",
    label: "Clickup",
  },
  {
    value: "smartsheet",
    label: "SmartSheet",
  },
  {
    value: "monday",
    label: "Monday",
  },
  {
    value: "bugherd",
    label: "Bugherd",
  },
  {
    value: "jira",
    label: "Jira",
  },
  {
    value: "spirateam",
    label: "SpiraTeam",
  },
  {
    value: "helix im",
    label: "Helix IM",
  },
  {
    value: "youtrack",
    label: "Youtrack",
  },
  {
    value: "backlog",
    label: "Backlog",
  },
  {
    value: "shortcut",
    label: "Shortcut",
  },
  {
    value: "asana",
    label: "Asana",
  },
  {
    value: "goodDay",
    label: "GoodDay",
  },
  {
    value: "gui testing",
    label: "GUI testing",
  },
  {
    value: "katalon platform",
    label: "Katalon Platform",
  },
  {
    value: "readyapi",
    label: "ReadyAPI",
  },
  {
    value: "accelq",
    label: "ACCELQ",
  },
  {
    value: "postman",
    label: "Postman",
  },
  {
    value: "rest-Assured",
    label: "REST-Assured",
  },
  {
    value: "swagger.io",
    label: "Swagger.io",
  },
  {
    value: "jmeter",
    label: "JMeter",
  },
  {
    value: "jarate dsl",
    label: "Karate DSL",
  },
  {
    value: "airborne",
    label: "Airborne",
  },
  {
    value: "pyresttest",
    label: "Pyresttest",
  },
  {
    value: "apigee",
    label: "Apigee",
  },
  {
    value: "sqlmap",
    label: "SQLMap",
  },
  {
    value: "BeEF (Browser Exploitation Framework)",
    label: "BeEF (Browser Exploitation Framework)",
  },
  {
    value: "zed attack proxy (ZAP)",
    label: "Zed Attack Proxy (ZAP)",
  },
  {
    value: "snyk",
    label: "Snyk",
  },
  {
    value: "intruder",
    label: "Intruder",
  },
  {
    value: "invicti",
    label: "Invicti/SQL",
  },
  {
    value: "sonarqube",
    label: "SonarQube",
  },
  {
    value: "sonatype",
    label: "Sonatype",
  },
  {
    value: "vega",
    label: "Vega",
  },
  {
    value: "google nogotofail",
    label: "Google Nogotofail",
  },
  {
    value: "kobiton",
    label: "Kobiton",
  },
  {
    value: "testrigor",
    label: "TestRigor",
  },
  {
    value: "accelq",
    label: "ACCELQ",
  },
  {
    value: "katalon platform",
    label: "Katalon Platform",
  },
  {
    value: "perfecto",
    label: "Perfecto",
  },
  {
    value: "testgrid",
    label: "TestGrid",
  },
  {
    value: "selendroid",
    label: "Selendroid",
  },
  {
    value: "calabash",
    label: "Calabash",
  },
  {
    value: "kif",
    label: "KIF",
  },
  {
    value: "post css",
    label: "Post CSS",
  },
  {
    value: "code beautify",
    label: "Code Beautify",
  },
  {
    value: "css lint",
    label: "CSS Lint",
  },
  {
    value: "beautify tools",
    label: "Beautify Tools",
  },
  {
    value: "w3c css validator",
    label: "W3C CSS Validator",
  },
  {
    value: "css redundancy checker",
    label: "CSS Redundancy Checker",
  },
  {
    value: "code beautifier",
    label: "Code Beautifier",
  },
  {
    value: "robot framework",
    label: "Robot Framework",
  },
  {
    value: "selenium",
    label: "Selenium",
  },
  {
    value: "playwright",
    label: "Playwright",
  },
  {
    value: "appium",
    label: "Appium",
  },
  {
    value: "test studio",
    label: "Test Studio",
  },
  {
    value: "api testing",
    label: "API testing",
  },
  {
    value: "unit testing",
    label: "Unit testing",
  },
  {
    value: "e2e testing",
    label: "E2E testing",
  },
  {
    value: "security / penetration testing",
    label: "Security / Penetration testing",
  },
  {
    value: "load testing",
    label: "Load testing",
  },
  {
    value: "test automation",
    label: "Test automation",
  },
  {
    value: "writing test plans",
    label: "Writing Test plans",
  },
  {
    value: "writing test cases",
    label: "Writing Test cases",
  },
  {
    value: "writing defect reports",
    label: "Writing defect reports",
  },
  {
    value: "knowledge of the testing process",
    label: "Knowledge of the testing process",
  },
];

export const roleInProject = [
  { value: "Product Owner", label: "Product Owner" },
  { value: "API Developer", label: "API Developer" },
  { value: "DBA Developer", label: "DBA Developer" },
  { value: "DevOps Engineer", label: "DevOps Engineer" },
  { value: "AI Developer", label: "AI Developer" },
  { value: "ML Expert", label: "ML Expert" },
  { value: "Data Scientist", label: "Data Scientist" },
  { value: "Software Developer", label: "Software Developer" },
  { value: "Full-stack Developer", label: "Full-stack Developer" },
  { value: "Front-end Developer", label: "Front-end Developer" },
  { value: "Back-end Developer", label: "Back-end Developer" },
  { value: "Business Analyst", label: "Business Analyst" },
  { value: "UX / UI Designer", label: "UX / UI Designer" },
  {
    value: "Software Tester / QA Engineer",
    label: "Software Tester / QA Engineer",
  },
  { value: "QA Lead / Test Manager", label: "QA Lead / Test Manager" },
  { value: "Project Manager", label: "Project Manager" },
  { value: "Enterprise Architect", label: "Enterprise Architect" },
  { value: "Software Architect", label: "Software Architect" },
  { value: "Scrum Master", label: "Product Owner" },
  { value: "Team Lead / Tech Lead", label: "Team Lead / Tech Lead" },
  { value: "Other", label: "Other" },
];

export const qaSkills = [
  {
    value: "api testing",
    name: "API testing",
  },
  {
    value: "unit testing",
    name: "Unit testing",
  },
  {
    value: "e2e testing",
    name: "E2E testing",
  },
  {
    value: "security testing/penetration tests",
    name: "Security testing/Penetration tests",
  },
  {
    value: "load testing",
    name: "Load testing",
  },
  {
    value: "test automation",
    name: "Test automation",
  },
  {
    value: "writing Test plans++",
    name: "Writing Test plans++",
  },
  {
    value: "writing Test cases",
    name: "writing test cases",
  },
  {
    value: "writing defect reports",
    name: "Writing defect reports",
  },
  {
    value: "knowledge of the testing process",
    name: "Knowledge of the testing process",
  },
  {
    value: "regression testing",
    name: "Regression testing",
  },
];

export const areasOfExpertise = [
  {
    value: "leading development teams",
    label: "Leading development teams",
  },
  {
    value: "solution design",
    label: "Solution design",
  },
  {
    value: "artificial intelligence",
    label: "Artificial intelligence",
  },
  {
    value: "cloud Computing",
    label: "Cloud Computing",
  },
  {
    value: "cybersecurity",
    label: "Cybersecurity",
  },
  {
    value: "information security",
    label: "Information security",
  },
  {
    value: "machine learning",
    label: "Machine learning",
  },
  {
    value: "data science",
    label: "Data science",
  },
  {
    value: "automation",
    label: "Automation",
  },
  {
    value: "development (applications and software)",
    label: "Development (applications and software)",
  },
  {
    value: "ux/ui Design",
    label: "UX/UI Design",
  },
  {
    value: "product Management",
    label: "Product Management",
  },
  {
    value: "api & integration management",
    label: "API & Integration Management",
  },
  {
    value: "software architecture",
    label: "Software architecture",
  },
  {
    value: "qa & testing",
    label: "QA & Testing",
  },
  {
    value: "iam (identity access management)",
    label: "IAM (Identity Access Management)",
  },
  {
    value: "cryptography",
    label: "Cryptography",
  },

  {
    value: "microservices",
    label: "Microservices",
  },
  {
    value: "bootstrapping",
    label: "Bootstrapping",
  },
  {
    value: "container technologies",
    label: "Container Technologies",
  },
  {
    value: "agile work methods",
    label: "Agile work methods",
  },
  {
    value: "infrastructure",
    label: "Infrastructure",
  },
  {
    value: "cms systems",
    label: "CMS Systems",
  },
  {
    value: "erp systems",
    label: "ERP systems",
  },
  {
    value: "crm systems",
    label: "CRM systems",
  },
  {
    value: "database design",
    label: "Database design",
  },
  {
    value: "Devops",
    label: "devops",
  },
  {
    value: "configuration management",
    label: "Configuration Management",
  },
  {
    value: "web development",
    label: "Web development",
  },
  {
    value: "mobile development",
    label: "Mobile development",
  },
  {
    value: "payments",
    label: "Payments",
  },
  {
    value: "continuous delivery",
    label: "Continuous Delivery",
  },
  {
    value: "data migration",
    label: "Data migration",
  },
  {
    value: "mobile app design",
    label: "Mobile app design",
  },
  {
    value: "scrum master",
    label: "Database design",
  },
  {
    value: "other",
    label: "Other",
  },
];
